import { useEffect, useState } from 'react';
import { Box, Container } from '@mui/material';
import PortalPageHeader from '../../common/PortalPageHeader';
import { PageDetails } from '../config';
import ActionHistoryDetails from './ActionHistoryDetails';

export default function ActionHistory(props) {
  const id = 'actionHistory';
  const [title, setTitle] = useState('');

  useEffect(() => {
    //θ(N) where N is the number of pages in PageDetails
    //Retrieve page title from pageDetails using id
    const loadPageTitle = () => {
      const page = PageDetails[id];
      setTitle(page.title);
    };
    loadPageTitle();
  }, []);

  return (
    <div id={`${id}__div_pageWrapper`} className={`myOdu__${id}`}>
      <Container
        id={`${id}__container_pageWrapper`}
        className="myOdu__container secondaryPage rightSideFullWidth"
      >
        <PortalPageHeader id={id} title={title} breadcrumbs={PageDetails[id].breadcrumbs} />
        <Box id={`${id}__box_wrapper`} className={'wrapper'}>
          <ActionHistoryDetails id={id} />
        </Box>
      </Container>
    </div>
  );
}
